import React from 'react';
import { css } from '@emotion/react';
import { i18n_search_meditations } from '@yi/i18n/phrases/i18n_search_meditations';

import { algolia } from '~/common';
import { getPageTitleByHrefPathname } from '~/src/common/finder-page';
import { useIsGreaterThanTabletLandscape } from '~/src/common/mediaQueries';
import { MEDITATIONS_PATHNAME } from '~/src/common/routes';
import { useCurrentUser } from '~/src/common/user';
import { breakpoints } from '~/styles';

import { DesktopFilters } from './DesktopFilters';
import { Hits } from './Hits';
import { MobileFilters } from './MobileFilters';
import { SEOText } from './SEOText';
import { AlgoliaSearch } from '../AlgoliaSearch';
import {
  Layout as FinderPageLayout,
  FinderPageResultsStats,
  FinderPageSearchBox,
  SearchBoxContainer,
  UnderSearchButtonGroup,
  ToggleGroupContainer,
  ClosedCaptionsToggle,
  NoPropsToggle,
} from '../FinderPage';
import { MeditationsIcon } from '../icons';
import { useLocale } from '../LocaleProvider';

const { getLocalizedIndex } = algolia;

const iconStyle = css({
  height: '24px',
  width: 'auto',
  [breakpoints.minTablet]: {
    height: '26px',
  },
  [breakpoints.minDesktop]: {
    height: '32px',
  },
});
/*
   the viewBox changed to be able to center icon.
   It's done locally (i.e. only here), because  we use this Icon in a lot of places
   and layout in other places can be broken, because of this change.
 */
const HeadingIcon: React.FC = () => <MeditationsIcon css={iconStyle} viewBox="0 0 24 16" />;

const { Body, Container, Footer, Header } = FinderPageLayout;

export const MeditationsPage: React.FC = () => {
  const { locale } = useLocale();

  const { isLoggedIn } = useCurrentUser();
  const indexName = getLocalizedIndex('meditations', locale);
  const indexes = React.useMemo(() => {
    return [
      {
        indexName,
      },
    ];
  }, [indexName]);

  const isGreaterThanTabletLandscape = useIsGreaterThanTabletLandscape();

  return (
    <Container>
      <Header loggedOut={!isLoggedIn}>
        <HeadingIcon /> {getPageTitleByHrefPathname(MEDITATIONS_PATHNAME, locale)}
      </Header>
      <Body>
        <AlgoliaSearch indexes={indexes} newestFirst>
          <SearchBoxContainer>
            {isLoggedIn && <FinderPageSearchBox placeholder={i18n_search_meditations(locale)} />}
            <UnderSearchButtonGroup>
              {isLoggedIn && (
                <ToggleGroupContainer hidden={!isGreaterThanTabletLandscape}>
                  <ClosedCaptionsToggle />
                  <NoPropsToggle />
                </ToggleGroupContainer>
              )}
              <MobileFilters hidden={isGreaterThanTabletLandscape} />
            </UnderSearchButtonGroup>
          </SearchBoxContainer>
          <DesktopFilters hidden={!isGreaterThanTabletLandscape} />
          <FinderPageResultsStats />
          <Hits />
        </AlgoliaSearch>
      </Body>
      <Footer>
        <SEOText />
      </Footer>
    </Container>
  );
};
